import React from 'react'

const TextInput = React.forwardRef(
  (
    { label, type, name, isTextArea, required, disabled, error, size, ...rest },
    ref
  ) => {
    const inputStyling =
      'shadow appearance-none border border-gray-400 rounded-md w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
    const isRequiredError = error?.message === 'Required'
    const errorClass = 'border-red-500'
    return (
      <section>
        <label
          htmlFor={name}
          className="mb-1 block text-sm font-bold text-black"
        >
          {label} {required && <span className="text-red-accent">*</span>}
        </label>
        {!isTextArea ? (
          <input
            className={`${inputStyling} ${error && errorClass} ${disabled && 'bg-input-gray'}`}
            type={type}
            name={name}
            disabled={disabled}
            ref={ref}
            maxLength={size}
            {...rest}
          />
        ) : (
          <textarea
            className={`${inputStyling} ${error && errorClass} h-44`}
            name={name}
            ref={ref}
            maxLength={size}
            {...rest}
          />
        )}
        {error && <p className="mt-1 text-sm text-red-500">{error?.message}</p>}
      </section>
    )
  }
)

export default TextInput
